import React, { useState } from 'react';
import { Input } from 'antd';
import NumberFormat from 'react-number-format';
import styled from 'styled-components';

const TextFieldWithLabel = props => {
  const [focused, setFocus] = useState(false);
  const { id, type, format, placeholderText, nameType, values, formValid, formErrors } = props;

  const handleFocus = event => {
    setFocus(true);
    if (props.handleFocus !== undefined) props.handleFocus(id);
  };

  const handleBlur = event => {
    setFocus(false);
    props.handleBlur(id, event.target.value);
  };

  const handleChange = event => {
    props.handleChange(id, event.target.value);
  };

  return (
    <TextFieldWithLabelContainer>
      <div className="helper text-field-helper">
        {focused ? nameType : formValid[id] === -1 ? formErrors[id] : nameType}
      </div>
      <div
        className={
          'text-field-wrapper' +
          (formValid[id] === 1
            ? ' input-success-value'
            : formValid[id] === -1
            ? ' input-failed-value'
            : '')
        }
      >
        {type === 'text' && (
          <Input
            className="text-field-input"
            name={id}
            value={values[id]}
            placeholder={placeholderText}
            maxLength={60}
            onBlur={handleBlur}
            onChange={handleChange}
            onFocus={handleFocus}
          />
        )}

        {type === 'number' && (
          <NumberFormat
            className="text-field-input"
            name={id}
            value={values[id]}
            placeholder={placeholderText}
            format={format}
            mask=""
            onBlur={handleBlur}
            onChange={handleChange}
            onFocus={handleFocus}
          />
        )}
      </div>
    </TextFieldWithLabelContainer>
  );
};

const TextFieldWithLabelContainer = styled.div`
  .text-field-helper {
    display: block;
    font-weight: bold;
    font-size: 20px;
    line-height: 120%;
    -webkit-letter-spacing: -0.01em;
    -moz-letter-spacing: -0.01em;
    -ms-letter-spacing: -0.01em;
    letter-spacing: -0.01em;
    color: var(--normal-title-color);
    font-family: Sofia Pro;

    &.input-failed-value {
      .text-field-input {
        border: 1px solid var(--input-failed-color);
      }

      .text-field-helper {
        display: block;
        border: 1px solid var(--input-failed-color);
        background: var(--input-failed-color);
      }
    }
  }

  .text-field-wrapper {
    position: relative;
    margin: 0;

    .text-field-input {
      height: 58px !important;
      border-radius: 0px !important;
      font-family: Sofia Pro;
      font-size: 20px !important;
      border: 1px solid #cfd8dc;
      width: 100%;
      padding: 21px 23px;
      letter-spacing: 0px !important;

      &::placeholder {
        color: var(--disabled-text-color);
        letter-spacing: 0px !important;
      }
    }

    &.input-success-value {
      .text-field-helper {
        display: block;
        border: 1px solid #cfd8dc;
        background: var(--input-success-color);
        color: var(--neutral-6);
      }
    }

    &.input-failed-value {
      .text-field-input {
        border: 1px solid var(--input-failed-color);
      }

      .text-field-helper {
        display: block;
        border: 1px solid var(--input-failed-color);
        background: var(--input-failed-color);
      }
    }

    .text-field-input:focus {
      border: 1px solid var(--input-selected-color);
      outline: none;
      box-shadow: none;

      & ~ .text-field-helper {
        display: block;
        border: 1px solid var(--input-selected-color);
        background: var(--input-selected-color);
        color: var(--white-color);
      }
    }
  }

  @media (max-width: 768px) {
    .text-field-wrapper {
      .text-field-input {
        height: 48px !important;
        font-size: 16px !important;
        padding: 12px 18px;
      }
    }
  }

  @media (max-width: 576px) {
  }
`;

export default TextFieldWithLabel;
